<template>
  <div class="error-page">
    <h2>Something went wrong</h2>
    <button
      class="error-page__btn"
      @click="handleError"
      data-attr="Error-Page"
      :disabled="isLoading"
    >
      <Loading v-if="isLoading" />
      <p v-else>Refresh</p>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

const user = useUserStore()

const isLoading = ref(false)

const tgHash = sessionStorage?.getItem('tma:hash')
const tgQueryParams = sessionStorage.getItem('tma:queryParams')

const route = `/${tgQueryParams ? tgQueryParams : ''}${tgHash ? tgHash : ''}`

const handleError = () => {
  isLoading.value = true
  if (user.playdeck) {
    clearError((window.location.href = route))
  } else {
    clearError((window.location.href = route))
  }
}
</script>

<style lang="scss" scoped>
.error-page {
  height: 100dvh;
  width: 100%;
  padding: 0 10px;
  background: rgba(11, 5, 21, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  z-index: 10000;
  position: absolute;

  h2 {
    font-weight: 400;
    font-size: $body1;
    color: #fff;
    //   font-family: Silkscreen;
  }
  &__btn {
    width: 290px;
    height: 60px;
    border-radius: 8px;
    background-color: $buttonColor;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: $body1;
    color: $navbarColor;
    gap: 15px;
    font-weight: 800;
    //   font-family: Silkscreen;
  }
}
</style>
